import { Component, EventEmitter, Input, Output } from '@angular/core';
export interface SegOption { label: string; value: any; }
@Component({
  selector: 'payarc-segmented',
  template: `
    <div class="pa-seg" [class.pa-seg--underline]="variant === 'underline'" role="tablist">
      <button type="button" class="pa-seg__item" *ngFor="let o of options"
        [class.pa-seg__item--active]="o.value === value" role="tab" [attr.aria-selected]="o.value === value"
        (click)="select(o.value)">{{ o.label }}</button>
    </div>`,
  styleUrls: ['./payarc-segmented.component.css'],
  standalone: false
})
export class PayarcSegmentedComponent {
  @Input() options: SegOption[] = [];
  @Input() value: any;
  @Input() variant: 'pill' | 'underline' = 'pill';
  @Output() valueChange = new EventEmitter<any>();
  select(v: any) { this.value = v; this.valueChange.emit(v); }
}
